module.exports = __webpack_public_path__ + "img/1.413444fb.png";